/**
 * HOA Sale Countdown — one engine for every timer on the storefront
 * ================================================================================
 * Deadline + copy come from window.HOA_SALE (snippets/hoa-sale-config.liquid).
 * Nothing here hardcodes a date; change the date in that snippet only.
 *
 * USAGE — drop an empty element anywhere (theme section, custom Liquid block,
 * GemPages HTML field) and this fills it in and ticks it every second:
 *
 *   <span data-hoa-countdown></span>            inline pill  (default)
 *   <span data-hoa-countdown="bare"></span>     numbers only, inherits styling
 *   <div  data-hoa-countdown="boxes"></div>     stacked boxes (D / HRS / MINS / SECS)
 *
 * Optional attributes:
 *   data-hoa-cd-label="Ends in"   prefix label (inline/bare only; "" removes it)
 *   data-hoa-cd-days="false"      roll days into hours instead of showing a D box
 *
 * The DOM is re-scanned on every tick, so timers injected AFTER load (marquee
 * clones, section re-renders, app-injected drawers) are picked up automatically.
 *
 * WHEN THE SALE ENDS: <html> gets .hoa-sale-over, every timer reads zero, and
 * anything marked [data-hoa-sale-only] is hidden. Copy stays put — swap it in
 * the theme editor when the next promo starts.
 *
 * NO DEADLINE (window.HOA_SALE.end blank — the current End of Season Sale):
 * <html> gets .hoa-sale-nodeadline, every [data-hoa-countdown] slot and every
 * [data-hoa-deadline-only] element is hidden by hoa-sale-timer.css, and this
 * engine does nothing else. Set a date in the config snippet and it all comes
 * back — no markup changes needed.
 */
(function () {
  if (window.__hoaSaleTimer) return; // idempotent per page load
  window.__hoaSaleTimer = true;

  var CFG = window.HOA_SALE || {};
  if (!CFG.end) {
    // Evergreen promo: nothing to count to. The config snippet already added
    // this class pre-paint; repeat it here in case the snippet was not rendered.
    document.documentElement.classList.add('hoa-sale-nodeadline');
    return;
  }
  var END = new Date(CFG.end).getTime();
  if (isNaN(END)) return;

  var UNITS = [
    { k: 'd', lbl: 'Days', short: 'd' },
    { k: 'h', lbl: 'Hrs', short: 'h' },
    { k: 'm', lbl: 'Mins', short: 'm' },
    { k: 's', lbl: 'Secs', short: 's' }
  ];

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function parts(diff, withDays) {
    if (diff < 0) diff = 0;
    var t = Math.floor(diff / 1000);
    var d = withDays ? Math.floor(t / 86400) : 0;
    var h = withDays ? Math.floor((t % 86400) / 3600) : Math.floor(t / 3600);
    return { d: d, h: h, m: Math.floor((t % 3600) / 60), s: t % 60 };
  }

  function build(el) {
    var style = el.getAttribute('data-hoa-countdown') || 'inline';
    var withDays = el.getAttribute('data-hoa-cd-days') !== 'false';
    var label = el.getAttribute('data-hoa-cd-label');
    if (label === null) label = style === 'boxes' ? '' : 'Ends in';

    var html = '';
    if (style === 'boxes') {
      html += '<div class="hoa-cd__boxes">';
      UNITS.forEach(function (u) {
        if (u.k === 'd' && !withDays) return;
        html += '<div class="hoa-cd__box"><div class="hoa-cd__num" data-hoa-cd="' + u.k + '">00</div>' +
                '<div class="hoa-cd__lbl">' + u.lbl + '</div></div>';
      });
      html += '</div>';
    } else {
      if (label) html += '<span class="hoa-cd__pre">' + label + '</span>';
      html += '<span class="hoa-cd__t">';
      UNITS.forEach(function (u, i) {
        if (u.k === 'd' && !withDays) return;
        if (i && !(i === 1 && !withDays)) html += '<span class="hoa-cd__sep">:</span>';
        html += '<span class="hoa-cd__u"><b data-hoa-cd="' + u.k + '">00</b><i>' + u.short + '</i></span>';
      });
      html += '</span>';
    }

    el.innerHTML = html;
    el.classList.add('hoa-cd', style === 'boxes' ? 'hoa-cd--boxes' : 'hoa-cd--inline');
    if (style === 'bare') el.classList.add('hoa-cd--bare');
    el.setAttribute('aria-live', 'off');
    el.__hoaBuilt = true;
  }

  function tick() {
    var diff = END - Date.now();
    var over = diff <= 0;
    var root = document.documentElement;
    if (over && !root.classList.contains('hoa-sale-over')) {
      root.classList.add('hoa-sale-over');
      var hide = document.querySelectorAll('[data-hoa-sale-only]');
      for (var j = 0; j < hide.length; j++) hide[j].style.display = 'none';
    }

    var nodes = document.querySelectorAll('[data-hoa-countdown]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!el.__hoaBuilt) build(el);
      var p = parts(diff, el.getAttribute('data-hoa-cd-days') !== 'false');
      var cells = el.querySelectorAll('[data-hoa-cd]');
      for (var c = 0; c < cells.length; c++) {
        var k = cells[c].getAttribute('data-hoa-cd');
        var v = k === 'd' ? String(p.d) : pad(p[k]);
        if (cells[c].textContent !== v) cells[c].textContent = v;
      }
    }
  }

  function start() {
    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
